import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import AppRoutePlan from 'views/customer/route-plan/AppRoutePlan';
import MainPage from 'views/main-page';

// customer page routing
const HeshIsrael = Loadable(lazy(() => import('views/auth-israel/index')));
const AppCustomerList = Loadable(lazy(() => import('views/customer/CustomerList')));
const AppSupplierList = Loadable(lazy(() => import('views/suppliers/SupplierList')));
const AllDocumentsTable = Loadable(lazy(() => import('views/customer/all-documents/AllDocuments')));
const AppAllProductsSpread = Loadable(lazy(() => import('views/customer/all-documents/AppDocumentsProductSpread')));
const AppAllProductsSpreadByDate = Loadable(lazy(() => import('views/customer/all-documents/AppDocumentsProductSpreadByDate')));
const AppAllPaysDescriptions = Loadable(lazy(() => import('views/customer/all-pay-spread/Table')));
const AppDeposits = Loadable(lazy(() => import('views/customer/deposits/DepositsPage')));
const AppAllCPDATA = Loadable(lazy(() => import('views/customer/all-cp-data/Table')));
const AllOpenOrders = Loadable(lazy(() => import('views/customer/all-open-orders/AllOpenOrders')));
const AllCanceledOrders = Loadable(lazy(() => import('views/customer/all-canceled-orders/AllCanceledOrders')));
const AllOpenInvoices = Loadable(lazy(() => import('views/customer/all-open-receipts/AllOpenReceipts')));
const AppAllDebts = Loadable(lazy(() => import('views/customer/all-debts/Table')));
const AppSupAllDebts = Loadable(lazy(() => import('views/suppliers/all-debts/Table')));
const AppAllCompare = Loadable(lazy(() => import('views/customer/all-client-compare/Table')));
const AppAllGiul = Loadable(lazy(() => import('views/customer/all-client-giul/Table')));
const AppAllVisit = Loadable(lazy(() => import('views/customer/all-client-visitation/Table')));
const AppAmountsSupTable = Loadable(lazy(() => import('views/suppliers/all-data/Table')));
const AppAmountsTable = Loadable(lazy(() => import('views/customer/all-data/Table')));
const AppDashboard = Loadable(lazy(() => import('views/customer/dashboard/Dashboard')));
const AppAnomalies = Loadable(lazy(() => import('views/customer/anomalies/Anomalies')));
const AppAllTaxNotes = Loadable(lazy(() => import('views/customer/all-tax-note-send/Table')));
const AppCustomerProfile = Loadable(lazy(() => import('views/customer/profile')));
const AppAllPricesCustomer = Loadable(lazy(() => import('views/products/prices-list/index')));
const AppAllPricesCost = Loadable(lazy(() => import('views/products/prices-list/speciel_prices')));
const AppCollectorManagement = Loadable(lazy(() => import('cdmanagment/src/main')));
const AppCustomerNewReceipt = Loadable(lazy(() => import('views/customer/profile/documents/receipt/NewReceipt')));
const AppCustomerNewDeliveryCertificate = Loadable(
    lazy(() => import('views/customer/profile/documents/deliveryCertificate/NewDeliveryCertificate'))
);
const AppRoutePlanner = Loadable(lazy(() => import('views/logistics/route-planner')));
const AppCustomerNewInvoice = Loadable(lazy(() => import('views/customer/profile/documents/invoice/NewInvoice')));
const AppCustomerNewOrder = Loadable(lazy(() => import('views/customer/profile/documents/orderNote/NewOrder')));
const AppCustomerProductsList = Loadable(lazy(() => import('views/products/customer-products')));
const AppSupplierProductsList = Loadable(lazy(() => import('views/products/supplier-products')));
const AppOrders = Loadable(lazy(() => import('views/orders/ordersNew')));
const AppOrdersAi = Loadable(lazy(() => import('views/orders/smart-orders')));
const AppOrdersTouch = Loadable(lazy(() => import('views/orders/orderTouch')));
const AppOrdersOld = Loadable(lazy(() => import('views/ordersold')));
const AccountProfile = Loadable(lazy(() => import('views/user')));
const AppAllCostumerReports = Loadable(lazy(() => import('views/customer/all-reports/allReportsIndex')));
const AppAdditionalReports = Loadable(lazy(() => import('views/customer/additional-reports/additionalReportsIndex')));
const UsersTable = Loadable(lazy(() => import('views/customer/users/UsersTable')));
const PortalsTable = Loadable(lazy(() => import('views/customer/users/PortalsTable')));
const AppSupplierAllDocuments = Loadable(lazy(() => import('views/suppliers/all-documents/SupplierAllDocuments')));
const AppSupplierAllProducts = Loadable(lazy(() => import('views/suppliers/all-documents/AppDocumentsProductSpread')));
const AppInventory = Loadable(lazy(() => import('views/products/inventory/AppInventory')));
const AppTaklit = Loadable(lazy(() => import('views/products/taklit/Table')));
const AppSentMessages = Loadable(lazy(() => import('views/customer/sent-messages/setMessages')));
const AppPriceOffers = Loadable(lazy(() => import('views/price-offers/PriceOffers')));
const AppPriceChanges = Loadable(lazy(() => import('views/customer/price-changes/Table')));
const AppOrderLinkControl = Loadable(lazy(() => import('views/orders/link-control/LinkControl')));
const AppOrderLinkSettings = Loadable(lazy(() => import('views/orders/link-settings/OrderLinkSettings')));
const AppMarketingCollage = Loadable(lazy(() => import('views/marketing-collage/MarketingCollage')));
const AppAttendance = Loadable(lazy(() => import('views/attendance/AttendancePage')));
const AppScheduledTasks = Loadable(lazy(() => import('views/customer/scheduled-tasks/ScheduledTasksPage')));
const AppOtherApp = Loadable(lazy(() => import('views/other-app/OtherAppPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <MainPage />
        },
        {
            path: '/dashboard',
            element: <AppDashboard />
        },
        {
            path: '/anomalies',
            element: <AppAnomalies />
        },
        {
            path: '/customer/customer-list',
            element: <AppCustomerList />
        },
        {
            path: '/customer/documents/all-documents',
            element: <AllDocumentsTable />
        },
        {
            path: '/customer/sent-messages',
            element: <AppSentMessages />
        },
        {
            path: '/customer/scheduled-tasks',
            element: <AppScheduledTasks />
        },
        {
            path: '/customer/documents/all-products-spread',
            element: <AppAllProductsSpread />
        },
        {
            path: '/customer/documents/all-products-spread-by-date',
            element: <AppAllProductsSpreadByDate />
        },
        {
            path: '/customer/documents/reciept',
            element: <AppAllPaysDescriptions />
        },
        {
            path: '/customer/documents/deposits',
            element: <AppDeposits />
        },
        {
            path: '/route-planner',
            element: <AppRoutePlanner />
        },
        {
            path: '/route-planner/:date',
            element: <AppRoutePlanner />
        },
        {
            // legacy URL of the demo-data optimizer
            path: '/routes-plan',
            element: <AppRoutePlanner />
        },
        {
            path: '/customer/cp-data',
            element: <AppAllCPDATA />
        },
        {
            path: '/customer/documents/open-orders',
            element: <AllOpenOrders />
        },
        {
            path: '/customer/documents/canceled-orders',
            element: <AllCanceledOrders />
        },
        {
            path: '/customer/documents/open-invoices',
            element: <AllOpenInvoices />
        },
        {
            path: '/reports/route-plan',
            element: <AppRoutePlan />
        },
        {
            path: '/reports/all-compare',
            element: <AppAllCompare />
        },     {
            path: '/reports/all-giul',
            element: <AppAllGiul />
        },
        {
            path: '/reports/all-reports',
            element: <AppAllCostumerReports />
        },
        {
            path: '/reports/additional-reports',
            element: <AppAdditionalReports />
        },
        {
            path: '/reports/all-visitation',
            element: <AppAllVisit />
        },
        {
            path: '/customer/all-debt',
            element: <AppAllDebts />
        },
        {
            path: '/reports/all-amount',
            element: <AppAmountsTable />
        },
        {
            path: '/supplier/all-amount',
            element: <AppAmountsSupTable />
        },
        {
            path: '/customer/all-tax-note',
            element: <AppAllTaxNotes />
        },
        {
            path: '/customer/users',
            element: <UsersTable />
        },
        {
            path: '/customer/portals',
            element: <PortalsTable />
        },
        {
            path: '/customer/:id',
            element: <AppCustomerProfile />
        },
        {
            path: '/products/:id',
            element: <AppAllPricesCustomer />
        },
        {
            path: '/products/cost',
            element: <AppAllPricesCost />
        },
        {
            path: '/customer/:id/documents/createReceipt',
            element: <AppCustomerNewReceipt />
        },
        {
            path: '/customer/:id/documents/createOrder',
            element: <AppCustomerNewOrder />
        },
        {
            path: '/customer/:id/documents/createDeliveryCertificate',
            element: <AppCustomerNewDeliveryCertificate />
        },
        {
            path: '/customer/:id/documents/createInvoice',
            element: <AppCustomerNewInvoice />
        },
        {
            path: '/customer/:id/documents/createRefund',
            element: <AppCustomerNewInvoice />
        },
        {
            path: '/products/customer-products',
            element: <AppCustomerProductsList />
        },
        {
            path: '/products/supplier-products',
            element: <AppSupplierProductsList />
        },
        {
            path: '/orders',
            element: <AppOrdersOld />
        },
        {
            path: '/orders-new',
            element: <AppOrders />
        },
        {
            path: '/orders-ai',
            element: <AppOrdersAi />
        },
        {
            path: '/order_touch',
            element: <AppOrdersTouch />
        },
        {
            path: '/account-profile',
            element: <AccountProfile />
        },
        {
            path: '/reports/tax-israel',
            element: <HeshIsrael />
        },
        {
            path: '/supplier/supplier-list',
            element: <AppSupplierList />
        },
        {
            path: '/supplier/all-documents',
            element: <AppSupplierAllDocuments />
        },
        {
            path: '/supplier/all-products-spread',
            element: <AppSupplierAllProducts />
        },
        {
            path: '/supplier/all-debt',
            element: <AppSupAllDebts />
        },
        {
            path: '/products/inventory',
            element: <AppInventory />
        },
        {
            path: '/products/taklit',
            element: <AppTaklit />
        },
        {
            path: '/customer/price-offers',
            element: <AppPriceOffers />
        },
        {
            path: '/customer/price-changes',
            element: <AppPriceChanges />
        },
        {
            path: '/orders/link-settings',
            element: <AppOrderLinkSettings />
        },
        {
            path: '/orders/link-control',
            element: <AppOrderLinkControl />
        },
        {
            path: '/customer/marketing-collage',
            element: <AppMarketingCollage />
        },
        {
            path: '/attendance',
            element: <AppAttendance />
        },
        {
            path: '/other-app',
            element: <AppOtherApp />
        }
    ]
};

export default MainRoutes;
